import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { HighchartsComponent } from 'app/modules/shared/highcharts/highcharts.component';
import { ApiService } from 'app/modules/shared/services/api.service';
import * as moment from 'moment';
import { resolveAxisAnchorDate } from 'app/shared/utils/analytics-axis.util';
import * as momenttz from 'moment-timezone';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import * as FileSaver from 'file-saver';
import { MatSort } from '@angular/material/sort';
import { AdvanceVectoringService } from 'app/analytic/advance-vectoring.service'
import { MatDialog } from '@angular/material/dialog';
import { TableComponent } from '../../table/table.component';
import { AdvanceVectoringTableComponent } from '../../table/advance-vectoring-table/advance-vectoring-table.component';

interface UsageAnalytics {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-basic-advance-analytic',
  templateUrl: './basic-advance-analytic.component.html',
  styleUrls: ['./basic-advance-analytic.component.css']
})
export class BasicAdvanceAnalyticComponent implements OnInit, OnDestroy {
  countAPIData: any;
  @Input() dateData$: Subject<any>;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  advanceTableHeading: any[] = [];
  missionType: any;
  dataSource: MatTableDataSource<any>;
  usageAnalyticsSelectedValue: string = 'All';
  updateChart = false;
  isTableLoading = false;
  isGraphLoading = false;
  private inFlightRequests = 0;
  displayedColumns: string[] = ['sessionDate', 'completedAircrafts', 'damagedAircrafts', 'receivedBonuses', 'voiceCommands', 'textCommands', 'separationViolation', 'status'];
  totalLessionsSessions = 7;
  @ViewChild(HighchartsComponent, { static: false }) highchartsComponent: HighchartsComponent;
  userTimeZone: any;

  missionRecords: any = [];
  type: string = 'Day';
  pageNo: number = 0;
  pageSize: number = 5;



  usageEramAnalytics: UsageAnalytics[] = [
    { viewValue: 'All', value: 'All' },
    { viewValue: 'Average Missions Duration', value: 'AvgMissionDuration' },
    { viewValue: 'Total Missions Sessions', value: 'TotalMissions' },
    { viewValue: 'Total Cleared Missions', value: 'ClearedMissions' },

    { viewValue: 'Total Not Cleared Missions', value: 'NotClearedMissions' },
    { viewValue: 'Total Voice Commands', value: 'VoiceCommands' },
    { viewValue: 'Total Text Commands', value: 'TextCommands' },
    { viewValue: 'Total Separation Violations', value: 'separationViolation' }
  ];
  usageBasicAdvanceAnalytics: UsageAnalytics[];
  footerNames: { name: string; color: string; }[];
  dateType: { type: string; from: string; to: string; count: number; };
  sessionPlayedChartLabels: any[];
  sessionPlayedChartDatasets: { data: any; label: string; }[];
  graphAPIResponse: any;

  dayType: string = 'day';
  subSink: Subscription;
  missionName: string;
  usageType: any = 'All';
  startDate: any;
  endDate: any;
  dateInfo: any;
  constructor(private api: ApiService, private service: AdvanceVectoringService, private dialog: MatDialog,
  ) {
    this.userTimeZone = momenttz().tz('America/New_York');

  }

  ngOnInit(): void {
    let missionData = localStorage.getItem('selectedApp');
    if (JSON.parse(missionData).title == 'Advanced Vectoring') {
      this.missionName = JSON.parse(missionData).missionName;
      this.missionType = JSON.parse(missionData).missionType;
      this.dateInfo = JSON.parse(localStorage.getItem('dateRange'));
      this.subSink = this.dateData$.pipe(debounceTime(500),
        distinctUntilChanged()).subscribe(next => {
          if (this.dateInfo) {
            next = this.dateInfo;
          }

          this.dateType = { type: '', from: '', to: '', count: 0 };
          this.dateType.type = next.type ? next.type.toLowerCase() : 'day';
          this.dateType.from = next.from ? next.from : moment(new Date()).format('YYYY-MM-DD');
          this.dateType.to = next.to ? next.to : moment(new Date()).subtract(30, 'days');
          this.dateType.count = next.count ? next.count : 30;
          this.startDate = moment(next.startDate).format('YYYY-MM-DD');
          this.endDate = moment(next.endDate).format('YYYY-MM-DD');
          this.initialLoad();
        });
    }
  }

  initialLoad() {
    this.getSessionCountData(this.dateType.type.toLowerCase(), this.missionType.replace('[', '%5B').replace(']', '%5D'));
    this.getPerticularMissionData(this.dateType.type.toLowerCase(), this.missionType.replace('[', '%5B').replace(']', '%5D'));
    this.updateChart = false;
    this.getGraphDetails(this.dateType.type.toLowerCase(), this.missionType.replace('[', '%5B').replace(']', '%5D'), this.usageType);
  }

  getGraphConfiguration() {

    if (this.dateType.type == 'day') {
      this.dateType =
        { type: 'Day', from: moment(new Date()).format('YYYY-MM-DD'), to: moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD'), count: 30 };

      this.sessionPlayedChartLabels = this.getLastThirtyDaysDefault(this.dateType);
    } else if (this.dateType.type == 'month') {
      this.sessionPlayedChartLabels = this.getLastTwentyFourMonthDefault(this.dateType.from);
    }
    else if (this.dateType.type == 'year') {
      this.sessionPlayedChartLabels = this.getLastFiveYearsDefault(this.dateType.from);
    } else if (this.dateType.type == 'range') {
      let selectedFromDate = this.startDate;
      let selectedEndDate = this.endDate;
      this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEndDefault(selectedFromDate, selectedEndDate);
    }
    let AvgMissionDuration = this.graphAPIResponse[0].AvgMissionDuration ? this.graphAPIResponse[0].AvgMissionDuration.map(v => (Number(v))) : this.graphAPIResponse[0].AvgMissionDuration;
    let ClearedMissions = this.graphAPIResponse[0].ClearedMissions ? this.graphAPIResponse[0].ClearedMissions.map(v => (Number(v))) : this.graphAPIResponse[0].ClearedMissions;
    let NotClearedMissions = this.graphAPIResponse[0].NotClearedMissions ? this.graphAPIResponse[0].NotClearedMissions.map(v => (Number(v))) : this.graphAPIResponse[0].NotClearedMissions;
    let TextCommands = this.graphAPIResponse[0].TextCommands ? this.graphAPIResponse[0].TextCommands.map(v => (Number(v))) : this.graphAPIResponse[0].TextCommands;
    let TotalMissions = this.graphAPIResponse[0].TotalMissions ? this.graphAPIResponse[0].TotalMissions.map(v => (Number(v))) : this.graphAPIResponse[0].TotalMissions;
    let VoiceCommands = this.graphAPIResponse[0].VoiceCommands ? this.graphAPIResponse[0].VoiceCommands.map(v => (Number(v))) : this.graphAPIResponse[0].VoiceCommands;
    let separationViolation = this.graphAPIResponse[0].separationViolation ? this.graphAPIResponse[0].separationViolation.map(v => (Number(v))) : this.graphAPIResponse[0].separationViolation;

    this.sessionPlayedChartDatasets = [];

    if (this.usageType == 'All' || this.usageType == 'AvgMissionDuration') {
      this.sessionPlayedChartDatasets.push({ data: AvgMissionDuration, label: 'Average Missions Duration' });
    }
    if (this.usageType == 'All' || this.usageType == 'TotalMissions') {
      this.sessionPlayedChartDatasets.push({ data: TotalMissions, label: 'Total Missions Sessions' });
    }
    if (this.usageType == 'All' || this.usageType == 'ClearedMissions') {
      this.sessionPlayedChartDatasets.push({ data: ClearedMissions, label: 'Total Cleared Missions' });
    }
    if (this.usageType == 'All' || this.usageType == 'NotClearedMissions') {
      this.sessionPlayedChartDatasets.push({ data: NotClearedMissions, label: 'Total Not Cleared Missions' });
    }
    if (this.usageType == 'All' || this.usageType == 'VoiceCommands') {
      this.sessionPlayedChartDatasets.push({ data: VoiceCommands, label: 'Total Voice Commands' });
    }
    if (this.usageType == 'All' || this.usageType == 'TextCommands') {
      this.sessionPlayedChartDatasets.push({ data: TextCommands, label: 'Total Text Commands' });
    }
    if (this.usageType == 'All' || this.usageType == 'separationViolation') {
      this.sessionPlayedChartDatasets.push({ data: separationViolation, label: 'Total Separation Violations' });
    }

    const timepointPlayed = this.graphAPIResponse?.[0]?.["Timepoint"];

    if (timepointPlayed) {
      if (this.dateType.type == 'day' || this.dateType.type == 'Day') {
        this.sessionPlayedChartLabels = this.getLastThirtyDays(timepointPlayed);
      } else if (this.dateType.type == 'month' || this.dateType.type == 'Month') {
        this.sessionPlayedChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
      } else if (this.dateType.type == 'year' || this.dateType.type == 'Year') {
        this.sessionPlayedChartLabels = timepointPlayed;
      } else if (this.dateType.type == 'range') {
        this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
      }
    }
    this.updateChart = true;
    this.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
    this.dateInfo = undefined;

  }

  getSessionCountData(day, game) {
    this.service.getSessionCountData(day, game, this.dateType.type, this.startDate, this.endDate).subscribe(response => {
      this.countAPIData = response;
    })
  }

  getPerticularMissionData(day, game) {
    this.startTableLoad();
    this.service.getPerticularMissionData(day, game, this.dateType.type, this.startDate, this.endDate).pipe(debounceTime(500),
      distinctUntilChanged()).subscribe(response => {
        this.finishLoad();
        this.missionRecords = response;
        this.paginateDate();

      })
  }

  paginateDate() {
    // let startIndex = this.pageNo * this.pageSize;
    // let endIndex = (this.pageNo + 1) * this.pageSize;
    this.dataSource = new MatTableDataSource(this.missionRecords);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

  }

  onPageChange(event: PageEvent) {
    this.pageNo = event.pageIndex;
    this.pageSize = event.pageSize;
    // this.paginateDate();
    this.dataSource = new MatTableDataSource(this.missionRecords);

    this.dataSource.paginator = this.paginator;


  }

  changeAnalytics(event) {
    this.usageType = event;
    this.updateChart = false;

    this.getGraphDetails(this.dateType.type.toLowerCase(), this.missionType.replace('[', '%5B').replace(']', '%5D'), event);
  }

  getGraphDetails(day, missionType, usageType) {
    this.startGraphLoad();
    this.service.getGraphDetails(day, missionType, usageType, this.dateType.type, this.startDate, this.endDate).subscribe(response => {
      this.finishLoad();
      this.updateChart = false;
      this.graphAPIResponse = response;
      this.getGraphConfiguration();
    })
  }

  updateChartData(label: string[], dataset: any) {
    this.highchartsComponent.updateChartData(label, dataset);
  }

  getLastThirtyDaysDefault(data) {
    let daysDate = [];
    // SG-8323 (Issue 8): anchor the axis to the date that was requested rather than the
    // browser clock, so a client/server disagreement about "today" cannot shift every label.
    const anchorDate = resolveAxisAnchorDate(data);
    for (let i = 0; i <= data.count; i++) {
      let date = new Date(anchorDate);
      if (data.type === 'month' || data.type === 'Month') {
        const selectedMonth = moment(date).subtract(i, 'months');
        daysDate.push(moment(selectedMonth).format('MMM YYYY'));
      } else if (data.type === 'year' || data.type === 'Year') {
        var selectedYear = moment(date).subtract(i, 'years');
        daysDate.push(moment(selectedYear).format('YYYY'));
      } else {
        date.setDate(date.getDate() - i);
        daysDate.push(moment(date).format('ddd, MMM D'));
      }
    }
    return daysDate.reverse();
  }

  getLastTwentyFourMonthDefault(date) {
    let months = [];
    for (var i = 0; i < 24; i++) {
      var selectedMonth = moment(date).subtract(i, 'months');
      months.push(moment(selectedMonth).format('MMM YYYY'));
    }
    return months.reverse();
  }

  getLastFiveYearsDefault(date) {
    let years = [];
    for (var i = 0; i < 5; i++) {
      var selectedYear = moment(date).subtract(i, 'years');
      years.push(moment(selectedYear).format('YYYY'));
    }
    return years.reverse();
  }

  getDatesBetweenStartAndEndDefault(startDate, endDate) {
    let date = [];
    while (moment(startDate) <= moment(endDate)) {
      date.push(moment(startDate).format("ddd, MMM D"));
      startDate = moment(startDate).add(1, 'days').format("YYYY-MM-DD");
    }
    return date;
  }

  getLastThirtyDays(timepointPlayed: string[]): string[] {
    return timepointPlayed.map(dateStr => {
      const [month, day, year] = dateStr.split("-").map(Number);
      const date = new Date(year, month - 1, day);

      return date.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric"
      });
    });
  }

  getLastTwentyFourMonth(timepointPlayed: string[]): string[] {
    return timepointPlayed.map(dateStr => {
      const [month, year] = dateStr.split("-").map(Number);
      const date = new Date(year, month - 1);

      return date.toLocaleDateString("en-US", {
        month: "short",
        year: "numeric"
      });
    });
  }

  getDatesBetweenStartAndEnd(timepointPlayed: string[]): string[] {
    return timepointPlayed.map(dateStr => {
      const [month, day, year] = dateStr.split("-").map(Number);
      const date = new Date(year, month - 1, day);

      return date.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric"
      });
    });
  }

  exportCsvData(usage) {
    let type = this.dateType.type.toLowerCase();

    if (usage == 'usage') {
      this.service.getcsvDataForGraph(type, this.usageType, this.missionType.replace('[', '%5B').replace(']', '%5D'), this.startDate, this.endDate).subscribe(data => {
        let dataObject: any = data;
        if (data.type === 'application/zip') {
          var blob = new Blob([data], { type: data.type });
          FileSaver.saveAs(blob, usage.toUpperCase() + '.zip');
        } else {
          var blob = new Blob([data], { type: 'application/csv' });
          FileSaver.saveAs(blob, usage.toUpperCase() + '.csv');
        }
      })
    } else {
      this.service.getCsvDataForMission(type, this.missionType.replace('[', '%5B').replace(']', '%5D'), this.startDate, this.endDate).subscribe(data => {
        if (data.type === 'application/zip') {
          var blob = new Blob([data], { type: data.type });
          FileSaver.saveAs(blob, usage.toUpperCase() + '.zip');
        } else {
          var blob = new Blob([data], { type: 'application/csv' });
          FileSaver.saveAs(blob, usage.toUpperCase() + '.csv');
        }
      })
    }
  }

  openUserDialog(event) {
    let sessionDate = moment(event.sessionDate).format("YYYY-MM-DD")
    this.dialog.open(AdvanceVectoringTableComponent,
      {
        data: {
          api: `/analytics/advVectoringMissionAnalyticsUserUsage?missionType=${this.missionType.replace('[', '%5B').replace(']', '%5D')}&sessionDate=${sessionDate}`,
          header: 'Users/Nickname',
          rediretionUrl: 'main/user/details',
          redirectionKey: 'username',
          dateParameter: 'PracticeSet',
          mission: this.missionType,
          missionName: this.missionName
        },
        width: '900px',
        maxWidth: '95vw',
        maxHeight: '90vh',
        panelClass: 'table-dialog',
      })
  }
  //************************ SG-7046 start ****************
  getDynamicHeight(): number {
    // Your logic to calculate the dynamic height goes here
    // return 2 * 50; // Replace this with your actual logic
    const parentElement = document.getElementById('parentElement');
    const parentWidth = parentElement.clientWidth;
    return parentWidth;
  }
  getDynamicHeight1(): number {
    // Your logic to calculate the dynamic height goes here
    // return 2 * 50; // Replace this with your actual logic
    const parentElement = document.getElementById('parentElement1');
    const parentWidth = parentElement.clientWidth;
    return parentWidth;
  }
  getDynamicHeight2(): number {
    // Your logic to calculate the dynamic height goes here
    // return 2 * 50; // Replace this with your actual logic
    const parentElement = document.getElementById('parentElement2');
    const parentWidth = parentElement.clientWidth;
    return parentWidth;
  }
  // ***************SG-7046 start  *******************

  // Loader sync: when a date change reloads both the records table and the graph,
  // keep both overlays up until every in-flight request finishes, then clear them
  // together. A dropdown change only starts the graph request, so only that overlay shows.
  private startTableLoad() {
    this.isTableLoading = true;
    this.inFlightRequests++;
  }

  private startGraphLoad() {
    this.isGraphLoading = true;
    this.inFlightRequests++;
  }

  private finishLoad() {
    this.inFlightRequests = Math.max(0, this.inFlightRequests - 1);
    if (this.inFlightRequests === 0) {
      this.isTableLoading = false;
      this.isGraphLoading = false;
    }
  }

  ngOnDestroy(): void {
    if (this.subSink)
      this.subSink.unsubscribe();
  }
  // ***************SG-7046 end  *******************
}
